import { Text } from '@mnd-frontend/ui';
import { useCurrentPressroom } from '../../../../../../../contexts/CurrentPressroomContext';
import { BlueLink } from '../../styles';

const Tags = () => {
  const { pressroomId } = useCurrentPressroom();

  return (
    <>
      <Text as="h3" variant="headlineSmall">
        Categories
      </Text>
      <Text as="p" variant="body">
        Use categories to structure content in your newsroom and make it easy for your visitors to
        find the content they are looking for. A category categorizes a subject or a group of
        stories that are connected to each other. A story can have multiple categories at the same
        time.
      </Text>
      <br />
      <Text as="p" variant="body">
        Tags do not impact your reach.
      </Text>
      <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
        Keep them generic
      </Text>
      <Text as="p" variant="body">
        An example could be using the category People for a new important recruitment or Products
        for the launch of a new product line. Always try to keep categoriess as generic as possible
        - having too many different categoreis makes it harder for your readers to navigate your
        newsroom!
      </Text>
      <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
        Highlighted categories
      </Text>
      <Text as="p" variant="body">
        If you want to highlight certain categories, go to{' '}
        <BlueLink target="_blank" href={`/${pressroomId}/tag_management`}>
          Settings -{'>'} Category management
        </BlueLink>
        . A highlighted category shows up at the top of your news archive and media library.
      </Text>
    </>
  );
};

export default Tags;
